 let ga = {
    data(){
        return{
            category: "Pricing Calculator",
            label: window.location.href
        }
    },
    methods: {
        gaTrack(action){
            if(this.$ga !== undefined) {
                this.$ga.event({
                    eventCategory: this.category,
                    eventAction: action,
                    eventLabel: this.label
                })
            }
        }
    }
}

 export default ga